import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const EnrollStyle = makeStyles()((theme: Theme) => ({
  title: {
    marginBottom: 'unset',
    fontSize: '43px !important',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
    },
  },
  description: {
    lineHeight: '32px',
    fontSize: '18px',
  },
  learnMoreLink: {
    color: '#2E343B',
    fontSize: '14px',
    lineHeight: '24px',
    padding: '4px 0px',
  },
  checkDisabled: {
    '& .Mui-disabled': {
      color: '#BBBBC4',
    },
  },
  numberInput: {
    '& .PhoneInput': {
      width: '236px',
      height: '40px',
      padding: '9px',
      border: '1px solid #777',
      [theme.breakpoints.down('xs')]: {
        width: 'auto',
      },
    },
    '& .PhoneInput:hover': {
      border: '1px solid #222',
      borderRadius: '0px',
    },
    '& .PhoneInput:focus-within': {
      border: '1px solid #ff4500',
    },
    '& .PhoneInputCountryIcon ': {
      backgroundColor: 'none',
      boxShadow: 'unset',
      border: '0.5px solid #2223',
    },
    '& input': {
      fontSize: '16px',
      outline: 'none',
      border: 'none',
    },
  },
}))

export default EnrollStyle
